(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const BASE = (1 * 3600 + 24 * 60 + 7) * 1000;
  const pad = (n) => String(n).padStart(2, '0');
  const fmt = (ms) =>
    pad(Math.floor(ms / 3600000)) + ':' +
    pad(Math.floor(ms / 60000) % 60) + ':' +
    pad(Math.floor(ms / 1000) % 60) + ':' +
    pad(Math.floor((ms % 1000) / (1000 / 30)));

  // VHS timecode on the hero screen
  let clockRunning = false;
  function startClock() {
    const els = document.querySelectorAll('[data-wwa-timecode]');
    if (!els.length) return;
    if (reduceMotion) {
      els.forEach((el) => (el.textContent = fmt(BASE)));
      return;
    }
    if (clockRunning) return;
    clockRunning = true;
    const start = performance.now();
    let last = 0;
    const tick = (t) => {
      if (t - last > 90) {
        const text = fmt(BASE + (t - start));
        document.querySelectorAll('[data-wwa-timecode]').forEach((el) => (el.textContent = text));
        last = t;
      }
      requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  }

  // Product type filter chips on the Now Showing grid
  function bindFilters() {
    document.querySelectorAll('[data-wwa-filter]').forEach((group) => {
      if (group.dataset.wwaBound) return;
      group.dataset.wwaBound = 'true';
      const grid = document.querySelector('[data-wwa-grid="' + group.dataset.wwaFilter + '"]');
      if (!grid) return;
      group.addEventListener('click', (event) => {
        const chip = event.target.closest('button[data-type]');
        if (!chip) return;
        const type = chip.dataset.type;
        group.querySelectorAll('button[data-type]').forEach((b) => b.setAttribute('aria-pressed', b === chip ? 'true' : 'false'));
        grid.querySelectorAll('.wwa-card').forEach((card) => {
          const cardType = card.dataset.type;
          card.hidden = !(type === 'all' || cardType === 'all' || cardType === type);
        });
      });
    });
  }

  function init() {
    startClock();
    bindFilters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
